module.exports = __webpack_public_path__ + "img/trash-delete-bin.048119e3.svg";